<div class="banner d-none d-lg-flex" role="banner">
  <div class="container">
    <div class="title-wrapper">
      <img src="assets/images/banners/YouthBaseball.png" alt="" />
    </div>
  </div>
</div>
<fgb-mobile-header-bar [title]="'youth.page.title' | translate" [showPoints]="false"></fgb-mobile-header-bar>
<div class="mobile-content-wrapper">
  <div class="container content">
    <div class="video-box mb-2" *ifScreenSize="screenType.Desktop">
      <fgb-worksheet-list-carousel [isRallyCap]="true" [videoHeight]="'532px'"></fgb-worksheet-list-carousel>
    </div>
    <div class="video-box mb-2" *ifScreenSize="screenType.Mobile">
      <fgb-worksheet-list-carousel [isRallyCap]="true" [videoHeight]="'196px'"></fgb-worksheet-list-carousel>
    </div>

    <div class="row">
      <div class="video-container">
        <fgb-worksheet-list-carousel [videoHeight]="'170px'"></fgb-worksheet-list-carousel>
      </div>

      <div class="mt-3">
        <h4 [innerHTML]="'rallycap.contest.title' | translate | markdownTranslate"></h4>
        <p class="font-size-14" [innerHTML]="'rallycap.contest.description' | translate | markdownTranslate"></p>
      </div>

      <div class="my-3">
        <h4 [innerHTML]="'youth.rallycap.title' | translate | markdownTranslate"></h4>
        <p class="font-size-14" [innerHTML]="'rallycap.academy.description' | translate | markdownTranslate"></p>
      </div>

      <div class="mb-3">
        <h4 [innerHTML]="'youth.league.title' | translate | markdownTranslate"></h4>
        <p class="font-size-14" [innerHTML]="'youth.league.description' | translate | markdownTranslate"></p>
      </div>
    </div>
  </div>
</div>
